const tokenize = (value: string) =>
  value
    .toLowerCase()
    .split(/[^a-z0-9ąćęłńóśźżåäö]+/i)
    .filter(Boolean);

export default tokenize;
